<template>
    <div>
      <div class="border-bottom border-warning pb-2 mb-1 text-center">
        <small>انتخاب درگاه پرداخت</small>
      </div>
      <div>
        <span class="text-center" v-for="dargah in ListDargah" :key="dargah.id" >
          <img
            v-if="GetDay(dargah)"
            width="70"
            @click="ClickLogoDargah(dargah)"
            :src="dargah.fizicalImageUrl"
            alt="..."
            class="rounded Pointer"
            :class="Dargah == dargah.id ? 'SelectedImageIcon' : ''"
          />
        </span>
  </div>
      <div class="mt-3" v-for="dargah in ListDargah" :key="dargah.id">
        <small v-if="GetDay(dargah) && dargah.id==Dargah" >{{
          dargah.persianName
        }}</small>
      </div>
      <div class="mt-3">
        {{ Dargah_G }}
        <slot name="ContentButtonPayment"> </slot>
      </div>
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        Dargah: 0,
        ListDargah: [],
        IsFix: false,
      };
    },
    mounted() {
      this.GetListDargah();
    },
    computed: {
      Dargah_G() {
        this.$emit("GatewayCode", this.Dargah);
        this.$emit("IsFix", this.IsFix);
        return "";
      },
    },
    methods: {
      GetListDargah() {
        this.$Gateway().then((data) => {
          if (data.status == "Ok") {
            data.data.forEach((element) => {
              if ( (element.gatewayCode != null || element.gatewayCode != "") && element.isDefault == true ) {
                this.Dargah = element.id;
                this.IsFix = element.isFix;
              }
            });
            this.ListDargah = data.data;
          } else {
            this.$mySweetDefaultTost(
              "عدم وجود اطلاعات",
              data.msg,
              "warning",
              2000
            );
          }
        });
      },
      ClickLogoDargah(item) {
        this.Dargah = item.id;
        this.IsFix = item.isFix;
      },
      GetDay(dargah){
        var NowDay=this.$GetJalaliDate().split('/')[2];        
          if (dargah.gatewayCode != null) {
            if (NowDay>=dargah.activeDay.split('-')[0] && NowDay<=dargah.activeDay.split('-')[1] ) {
              this.Dargah = dargah.id;
                this.IsFix = dargah.isFix;
              return true
            }
          }
        
       
      }
    },
  };
  </script>
  <style scoped>
  .SelectedImageIcon {
    border: 2px dashed #ff9800 !important;
    height: 100px;
    width: 70px;
  }
  .border-warning {
    border-bottom: 1px dashed #ff9800 !important;
  }
  </style>
  